import Cookies from 'js-cookie'
import {updateClassInfo} from '@/api/classes'

const app = {
  state: {
    id: 0,
    avatar: '',
    realname: '',
    nickname: '',
    mobile: '',
    sex: 1,
    refresh_token: '',
    drops: 0,
    // 班主任积分
    reward: 0,
    binded_bot: 0,
    survey_url: '',
    reward_toal: 0,
    source: '',
    // 所有角色
    class_roles: [],

    // 用户所有信息
    // 包含但不限于上述信息
    user: {},
    user_settings: {},
    feature_badges: [],
    subscribe: 0,
    create_time: 0,
    wechat_top_up: 0,
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_REFRESH_TOKEN: (state, token) => {
      state.refresh_token = token
    },
    SET_REALNAME: (state, name) => {
      state.realname = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_SEX: (state, sex) => {
      state.sex = sex
    },
    SET_SOURCE: (state, source) => {
      state.source = source
    },
    SET_REWARD: (state, reward) => {
      state.reward = reward
    },
    SET_DROPS: (state, drops) => {
      state.drops = drops
    },
    SET_CLASS_ROLES: (state, roles) => {
      state.class_roles = roles
    },
    SET_USER_SETTINGS: (state, user_settings) => {
      state.user_settings = user_settings || {}
    },
    SET_FEATURE_BADGES: (state, feature_badges) => {
      state.feature_badges = feature_badges || []
    },
    SET_WECHAT_TOP_UP: (state, wechat_top_up) => {
      state.wechat_top_up = wechat_top_up || 0
    },
    SET_USER: (state, user) => {
      state.id = user.id
      state.realname = user.realname
      state.nickname = user.nickname
      state.avatar = user.avatar
      state.mobile = user.mobile
      state.sex = user.sex
      state.source = user.source
      state.reward_total = user.reward_total
      state.reward = user.reward
      state.drops = user.drops
      state.subscribe  = user.subscribe
      state.binded_bot = user.binded_bot
      state.survey_url = user.survey_url
      state.create_time = user.create_time
      state.class_roles = user.class_lists
      state.mp_active_time = user.mp_active_time
      state.is_mp_active = user.is_mp_active
      state.parent_mp_subscribe = user.parent_mp_subscribe
      state.teacher_mp_subscribe = user.teacher_mp_subscribe
      state.new_mp_subscribe = user.new_mp_subscribe
      state.wechat_top_up = user.wechat_top_up
      state.user = user
    }
  },
  actions: {
    // 去微信授权，refer为授权后返回的页面
    goWechatAuth({commit}, {refer,state}) {
      state = state || ''
      let appId = process.env.WECHAT_APP_ID
      refer = encodeURIComponent(refer)
      let redirectUri = encodeURIComponent(`${process.env.WEB_ORIGIN}/system/auth?refer=${refer}`)
      
      // 临时广告页面授权
      if (process.env.NODE_ENV != 'production' 
        && location.host == 'class.funp.in') {
        appId = 'wx143f89bcdca86ee2'
        redirectUri = encodeURIComponent(`http://class.funp.in/system/auth?refer=${refer}`)
      }
      // snsapi_base 仅获取openid，不弹出授权页面
      // snsapi_userinfo 弹出授权页面
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${state}`
      location.href = authUrl
    },
    updateUserInfo({commit}, {realname, mobile, avatar}) {
      commit('SET_REALNAME', realname)
      commit('SET_MOBILE', mobile)
      commit('SET_AVATAR', avatar)
    },
    updateClassRoles({commit}, classRoles) {
      commit('SET_CLASS_ROLES', classRoles)
    },
    reduceDrops({commit}, drops) {
      commit('SET_DROPS', this.drops - drops)
    },
    addDrops({commit}, drops) {
      commit('SET_DROPS', this.drops + drops)
    },
    reduceFlowers({commit}, flowers) {
      commit('SET_DROPS', this.state.user.drops - flowers * 100)
    },
    addFlowers({commit}, flowers) {
      commit('SET_DROPS', this.state.user.drops + flowers * 100)
    },
    setFlowers({commit}, flowers) {
      commit('SET_DROPS', flowers * 100)
    },
    updateClassInfo({commit}, params) {
      const class_id = params.id
      return new Promise((resolve, reject) => {
        updateClassInfo(class_id, params)
        .then((res) => {
          if (res.code == 1) {
            /**
             * 同步本地数据
             */
            const class_roles = this.getters.class_roles

            class_roles.forEach((classRole) => {
              const classInfo = classRole.class
              if (classInfo.id == class_id) {
                for(var prop in params) {
                  if (classInfo.hasOwnProperty(prop)) {
                    classInfo[prop] = params[prop]
                  }
                }

                if (params.school_name) {
                  classInfo['school'] = params.school_name
                }
              }
            })

            const roles = [].concat(class_roles)
            commit('SET_CLASS_ROLES', roles)

            resolve(res)
          } else {
            reject(res)
          }
        }).catch((e) => {
          reject(e)
        })
      })
    },
    closeGlobalMessage({commit}) {
      // localStorage.setItem('close_wechat_top_up_timestamp', new Date().getTime())
      commit('SET_WECHAT_TOP_UP', true)
    },
    toggleShowGlobalMessage({commit}, show) {
      let wechat_top_up = !show
      // if (show) {
      //   const timeStamp = localStorage.getItem('close_wechat_top_up_timestamp')
      //   if (timeStamp && new Date().getTime() - Number(timeStamp) < 86400000 * 3) {
      //     return
      //   }
      // }
      // console.log('toggleShowGlobalMessage', wechat_top_up, this.state.user.wechat_top_up)

      if (show && this.state.user.wechat_top_up) {
        return
      }
      commit('SET_WECHAT_TOP_UP', wechat_top_up)
    }

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/user.js